import React from 'react'
import { images } from 'Assets/Images'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { FormatMoney } from 'Utils/functions'
import { formatStartEndDate } from 'Utils/Helpers/formatDate'

const defTermValue = (startDate, endDate) =>
  `Promoción válida del ${formatStartEndDate(
    startDate,
    endDate
  )}. No aplica con otras promociones ni descuentos, precios no incluyen ITBMS. La tarjeta digital CMF es emitida por CM Financiera, S.A. (CMF). *Valor de cuota referencial, aplican condiciones. La responsabilidad de CMF se limita a los aspectos del crédito. Accede a www.cmf.com.pa para más información.`

export const Square5ToPrintNCmfOffer = ({ products, i }) => {
  const { templateRef, terms } = usePrinterContext()

  const prod = products?.content?.products?.[0]
  const prodBasePrice = FormatMoney(prod?.BasePrice || 0)
  const prodPrice = FormatMoney(prod?.Price || 0)

  const terms1 =
    terms?.find(term => term?.prodId === prod?.ProductId)?.value ||
    defTermValue(prod?.StartDate, prod?.FinishDate)

  return (
    <div style={{ width: '650px' }} ref={el => (templateRef.current[i] = el)}>
      <div
        id="printer-preview-left-canvas"
        data-testid="printer-preview-left-canvas"
        className="printer-preview-left-canvas">
        <div className="printer-preview-left-content-body">
          <p className="printer-preview-body-title-cmf">
            {prod?.ProductName || ''}
          </p>
          <p className="printer-preview-body-sku-cmf">{prod?.Sku || ''}</p>
          {prod?.BasePrice && (
            <div className="printer-preview-container-prices">
              <div className="printer-preview-content-price">
                <p
                  className="printer-preview-quote-1"
                  style={{
                    alignSelf: 'end',
                    marginBottom: 10,
                  }}>
                  36 cuotas desde
                </p>
                <div
                  className="printer-preview-container-price"
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 130,
                  }}>
                  <p className="printer-preview-price-simbol text-green-dark">
                    $
                  </p>
                  <p className="printer-preview-price text-green-dark">
                    {FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[0] || ''}
                  </p>
                  <p className="printer-preview-price-mini text-green-dark">
                    .
                    {FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[1] || '00'}
                  </p>
                </div>
              </div>
              <div className="printer-preview-content-price">
                <p className="printer-preview-quote-2">24 cuotas desde</p>
                <div className="printer-preview-container-price">
                  <p className="printer-preview-price-simbol-small text-green-dark">
                    $
                  </p>
                  <p className="printer-preview-price-small text-green-dark">
                    {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[0] || ''}
                  </p>
                  <p className="printer-preview-price-small-mini text-green-dark">
                    .
                    {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[1] ||
                      '00'}
                  </p>
                </div>
              </div>
              <div className="printer-preview-content-price">
                <p className="printer-preview-quote-2">12 cuotas desde</p>
                <div className="printer-preview-container-price">
                  <p className="printer-preview-price-simbol-small text-green-dark">
                    $
                  </p>
                  <p className="printer-preview-price-small text-green-dark">
                    {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[0] || ''}
                  </p>
                  <p className="printer-preview-price-small-mini text-green-dark">
                    .
                    {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[1] ||
                      '00'}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className="printer-preview-left-content-footer"
          style={{
            marginBottom: -12,
          }}>
          {prod?.BasePrice && (
            <div className="printer-preview-footer-container-prices-offer  printer-preview-footer-prices-dividers">
              <div className="printer-preview-footer-vertical-divider" />
              <div className="printer-preview-footer-container-price">
                <div className="printer-preview-price-before border-red" />
                <p className="printer-preview-footer-price">Antes</p>
                <p className="printer-preview-price-small">
                  {'$' + prodBasePrice}
                </p>
              </div>

              <div className="printer-preview-footer-container-price">
                <p className="printer-preview-footer-price text-red">Ahora</p>
                <p className="printer-preview-price-small text-red">
                  {'$' + prodPrice}
                </p>
              </div>
            </div>
          )}

          <div className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove">
            <p
              defaultValue={terms1}
              className="printer-preview-left-content-footer-legal-1"
              style={{
                fontSize: '9px',
                color: '#000',
                height: '40.5px',
                background: 'transparent',
              }}>
              {terms1}
            </p>
          </div>
        </div>
        <img
          className="printer-preview-left-image"
          src={images.printer.templates.novey.cmfOffer4}
          alt="template-preview"
          style={{ opacity: 0 }}
        />
      </div>
    </div>
  )
}
